import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import i18n from '../../strings/i18n';
import { cancelLimitIncreaseForm, closeButton, requestLimitIncrease } from '../../../../const/analytics';
import { Footer } from '../subcomponents';
const CreditLimitIncreaseFooter = ({ isPrimaryDisabled, isSecondaryDisabled, hasErrorOrSuccess, fetchLimitIncrease, handleCancel }) => {
    const { t: translate } = useTranslation(undefined, { i18n });
    const footerProps = {
        form: {
            primaryText: translate('button.requestIncrease'),
            handlePrimaryButton: fetchLimitIncrease,
            secondaryText: translate('button.cancel'),
            secondaryButtonType: 'ghost',
            handleSecondaryButton: handleCancel,
            ...cancelLimitIncreaseForm,
            ...requestLimitIncrease
        },
        statusMessage: {
            primaryText: translate('button.close'),
            handlePrimaryButton: handleCancel,
            ...closeButton
        }
    };
    return (_jsx(Footer, { isPrimaryDisabled: isPrimaryDisabled, isSecondaryDisabled: isSecondaryDisabled, ...(hasErrorOrSuccess ? footerProps.statusMessage : footerProps.form) }));
};
export default CreditLimitIncreaseFooter;
